import { useIsWithinTailWindBreakpoint } from 'noddi-ui-web';
import NewBookingButton from './NewBookingButton';

export const NewBookingButtonScalable = () => {
  const isMd = useIsWithinTailWindBreakpoint('md');
  return <NewBookingButton defaultSize={!isMd} />;
};
